// Path to the logged-in user's own collection page.
// Uses the username saved at login so the address bar shows the same
// shareable /username link that logged-out visitors use. Falls back to
// /recipes (which redirects to /username once the profile loads) when
// the stored user has no username yet.
export function myPagePath() {
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    if (user && typeof user.username === 'string' && user.username.trim()) {
      return `/${encodeURIComponent(user.username.trim())}`;
    }
  } catch {
    // corrupted localStorage — fall through
  }
  return '/recipes';
}

// True when the logged-in user (from localStorage) owns the page for
// `param`, which may be a username or a legacy user-id UUID.
export function isOwnPage(param) {
  if (!param || !localStorage.getItem('adminToken')) return false;
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    if (!user) return false;
    const p = decodeURIComponent(param).toLowerCase();
    if (user.username && String(user.username).toLowerCase() === p) return true;
    if (user.id && String(user.id).toLowerCase() === p) return true;
  } catch {
    // corrupted localStorage — treat as not owner
  }
  return false;
}
